<div class="reference_body">
  <main class="reference_main">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <div class="main">

      <div class="container">

    <div class="reference_view_table">
      <div class="gmou">
        <div class="the_header_view">
          <div class="row">
            <div class="col-md-6">
              <h3 class="header" style="margin-top: 2rem;">Projects</h3>
            </div>
            <div class="col-md-6">
              <div class="filter_button pull-right">
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                  <mat-button-toggle value="grid" routerLink="/project"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back</mat-button-toggle>
                  <mat-button-toggle mat-raised-button value="grid" color="primary" (click)="filterProjectModal()"><mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</mat-button-toggle>
                </mat-button-toggle-group>
                <!-- <button mat-raised-button color="primary" (click)="openCreateActivityModal()"> <mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</button> -->
               </div>
            </div>
          </div>
        </div>



        <div class="monitor_project_drop">


          <div class="other_details" *ngIf="status" [@fadeInAnimation]>

            <div class="the_card" id="print-section">
              <div class="row top_information">
                <div class="company col-md-8">
                  <h4 class="the__name" style="margin-bottom: 3rem;">
                    <!-- <img src="assets/images/components/icons8-microsoft-excel-50.png" height="40px" alt="" class="company_logo"> -->
                     Project
                  </h4>
                </div>
                <div class="real_time col-md-4 mb-3">
                  <!-- <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                    <mat-button-toggle value="grid" (click)="onListView()"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back</mat-button-toggle>
                    <mat-button-toggle mat-raised-button value="grid" (click)="openActivityModal()"><mat-icon class="example-tab-icon">visibility</mat-icon> View Activity</mat-button-toggle>
                  </mat-button-toggle-group> -->
                  <!-- <button mat-raised-button>Add New Project</button> -->

                </div>
              </div>

              <!-- <h4 class="the___top-heading" *ngIf="GMOUName">project detail report for {{GMOUName}}</h4> -->
              <div class="other_details"  [@fadeInAnimation]>
                <div class="the_card the__detail-card">
                  <div class="detail__info">
                    <h4 class="label">
                        <span class="labels" style="display: block;">State</span>
                        <span class="the__input" *ngFor="let data of ProjectData?.States">
                          {{data?.StateName}}
                        </span>
                    </h4>
                </div>
                <div class="detail__info">
                    <h4 class="label">
                        <span class="labels" style="display: block;">LGA</span>
                        <span class="the__input" *ngFor="let data of ProjectData?.Lgas">
                       {{data?.LgaName}}
                        </span>
                    </h4>
                </div>
                <div class="detail__info">
                    <h4 class="label">
                        <span class="labels" style="display: block;" *ngIf="genericBlockLabel">{{genericBlockLabel}}</span>
                        <div class="the__input" *ngFor="let oilBlock of ProjectData?.OilBlocks">
                        {{oilBlock?.OilBlockName}}
                        </div>
                    </h4>
                </div>
                <div class="detail__info">
                    <h4 class="label">
                        <span class="labels" style="display: block;" *ngIf="genericFieldLabel">{{genericFieldLabel}}</span>
                        <div class="the__input" *ngFor="let oilField of ProjectData?.OilFields">
                          {{oilField?.OilFieldName}}
                        </div>
                    </h4>
                </div>
              </div>

                <h4 class="description">
                  <span class="label">Project description</span>
                  <span class="described">{{ProjectData?.Description}}</span>
              </h4>

              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;">Project executor</span>
                      <span class="the_input">{{ProjectData?.Executor}}</span>
                  </h4>
              </div>
              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;">Start date</span>
                      <span class="the_input">{{ProjectData?.StartDate | date}}</span>
                  </h4>
              </div>
              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;">End date</span>
                      <span class="the_input">{{ProjectData?.EndDate | date}}</span>
                  </h4>
              </div>
              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;">Budget</span>
                      <span class="the_input">{{ProjectData?.Budget | currency:'NGN':'symbol-narrow'}}</span>
                  </h4>
              </div>

            </div>

              <!-- ==============================MAIN TABLE STARTS-===========================MAIN TABLE STARTS====== -->
              <div class="row mt-5 alert alert-success">
                <div class="col-md-11">

                    <p><em class="ti-info"></em>  The Table below shows the selected Project Budget Performance </p>

                </div>
              </div>
               <div class="reference_table" style="margin-top: 0rem;">
                  <!-- ==============================MAIN TABLE STARTS-===========================MAIN TABLE STARTS====== -->

                  <div class="table payroll-table">
                      <div class="thead payroll">
                          <span class="head">S/N</span>
                          <span class="head">Amount</span>
                          <span class="head">Invoice No.</span>
                          <span class="head">Payment Date</span>
                          <span class="head">Beneficiary Name</span>

                      </div>

                      <div class="tbody">
                          <div class="td  payroll" *ngFor="let payment of monitorProjectPaymentForm.get('MonitorProjectPayments')['controls']; index as i" (click)="openViewPaymentModal(payment.value)" style="cursor: pointer;">
                              <span class="head">{{i + 1}}</span>
                              <Span class="head" *ngIf="payment.value.CurrencyId">{{payment.value.Amount | currency:getCurrencyName(payment.value.CurrencyId):'symbol-narrow'}}</Span>
                              <Span class="head">{{payment.value.InvoiceNo}}</Span>
                              <Span class="head">{{payment.value.PaymentDate | date}}</Span>
                                <Span class="head">{{getBeneficiaryName(payment?.value?.BeneficiaryId)}}</Span>

                          </div>
                      </div>
                      <div class="total__amount">
                          <span class="word pr-3">Total Amount:</span>
                          <span class="main__amount">{{totalAmountPaid | currency:'NGN':'symbol-narrow'}}</span>
                      </div>
                      <!-- <div class="submit">
                          <button class="submit_button">Submit</button>
                      </div> -->
                  </div>
              </div>



            </div>

        </div>


      </div>
</div>
    </div>
</div>
</div>
</main>
</div>
